module.exports = __webpack_public_path__ + "img/TOSOLA_HERO.6184f7a0.png";